import React, { Component } from 'react';
import './style.css';


class NoList extends Component {
	render(){
		return(
			<div className="comnolist">
				没有数据哦!
			</div>
		)
	}
}

export default NoList;



